import { hm, language} from "./path";
import { parseJwt } from "./utils/jwt";
import { price } from "./filters/priceFilter";
import { cap, capPhrase } from "./utils/strings";
import HOMEMARKETS from "./data/homemarkets";

export * from "./utils/axios-instance"

export function getHm (url) {
    return hm(url);
}


export function getLanguage(url){
    return language(url);
}

export const parseToken = (token: string) => {
    return parseJwt(token);
};

export const priceFilter = (value: number, locale= "DE-de") => price(value, locale);
export const mask = (value: string | number, mask: string | string[]  = "", extraTokens: Object = {}) => {
  if (!value) return "";
  if (!mask) return value;

  const tokens = {
    "#": { pattern: /\d/ },
    X: { pattern: /[0-9a-zA-Z]/ },
    S: { pattern: /[a-zA-Z]/ },
    A: { pattern: /[a-zA-Z]/, transform: (v) => v.toLocaleUpperCase() },
    a: { pattern: /[a-zA-Z]/, transform: (v) => v.toLocaleLowerCase() },
    "!": { escape: true },
    K: { pattern: /[0-9kK]/, transform: (v) => v.toLocaleUpperCase() },
  };

  if (extraTokens) {
    Object.keys(extraTokens).forEach((key) => {
      tokens[key] = extraTokens[key];
    });
  }

  // CHECK IF MASK IS ARRAY
  const isArray = Array.isArray(mask);
  const maskTokens = Object.keys(tokens);
  const masks = (isArray ? mask : [mask]).reduce((acc: string[], m: string) => {
    const lm = m
      .split("")
      .map((m) => (maskTokens.includes(m) ? m : ""))
      .join("");
    if (maskTokens.includes(m)) acc.push(lm);
    if (lm.length) acc.push(lm);

    return acc;
  }, []);

  if (!masks.length) return "";

  let masked = "";
  let maskToApply = "";

  //  MASK MACHED IN LENGTH WITH VALUE
  if (masks.length > 1) {
    masks.forEach((m: string, j: number) => {
      if (m.length === value?.toString()?.length) {
        maskToApply = (isArray ? mask : [mask])[j];
      }
    });
  } else {
    maskToApply = (isArray ? mask : [mask])[0];
  }

  let initPos = 0;
  value?.toString()?.split("").forEach((char) => {
    // ADD TO MASKED WHITE FOUND TOKEN
    maskToApply.split("").forEach((mChar, j, arr) => {
      if (j < initPos) return;

      if (tokens[mChar]) {
        const token = tokens[mChar];
        const { pattern, transform, escape } = token;
        if (escape) {
          masked += mChar;
          return;
        }
        if (pattern.test(char)) {
          masked += transform ? transform(char) : char;
        }
        // remove all items from this position
        initPos = j + 1;
        arr.splice(j, arr.length);
      } else {
        masked += mChar;
      }
    });
  });

  return masked;
};

export const capitalize = (value: string) => cap(value);

export const capitalizePhrase = (value: string) => capPhrase(value);

export const getBaseRouteByCountry = (country = "CL") => {
    const ROUTES = {
        CL: "es/chile",
        PE: "es/peru",
      };
      return ROUTES[country] || ROUTES.CL;
};

export const ROLES = {
  BUSINESS_ADMIN: "BUSINESS-ADMIN",
  ADMIN: "ADMIN",
  PAYER: "PAYER",
  BUYER: "BUYER",
  MANAGER_PE: "MANAGER-PE",
  DELEGATE_PE: "DELEGATE-PE",
};

export const getProfileLabel = (role: string) => {
  return (
    {
      [ROLES.BUSINESS_ADMIN]: "Administrador de empresas",
      [ROLES.ADMIN]: "Administrador de sucursal",
      [ROLES.PAYER]: "Comprador",
      [ROLES.BUYER]: "Reservador",
      [ROLES.MANAGER_PE]: "Gestor",
      [ROLES.DELEGATE_PE]: "Delegado",
    }[role] || ""
  );
};

export const getCountrySlugFromPathname = (path: string) => {
  const business = path?.split("/")[2]
  const country = HOMEMARKETS[business?.toLowerCase() || "chile"] ;
  return country?.slug;
};

export const isChile = (country: string) => {
  return getCountrySlugFromPathname(country) === "cl";
};

export const isPeru = (country: string) => {
  return getCountrySlugFromPathname(country) === "pe";
};
